import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/companies/companiesplacessaga/REQUEST';
export const SUCCESS = '@app/companies/companiesplacessaga/SUCCESS';
export const FAILURE = '@app/companies/companiesplacessaga/FAILURE';
export const CLEAR = '@app/companies/companiesplacessaga/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: true,
    placeItems: []
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case FAILURE:
                draft.errorStatus = payload;
                break;
            case CLEAR:
                draft.placeItems = [];
                break;
            case SUCCESS:
                draft.placeItems = payload;
                draft.loading = false;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data)
};

/**
 * Saga functions
 */
export const sagas = {
    *request() {
        try {
            yield put(creator(CLEAR));
            const items = [];
            const response = yield axios.get('/companies/places');
            yield response.data.data.filter((x) => items.push({ value: x.name, label: x.name }));
            yield put(actions.success(items));
        } catch (e) {
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
